import React from "react";
import image1 from "../img/Artboard 20-100.jpg";
import image2 from "../img/Jaytrends Slider-100.jpg";
import image3 from "../img/Page 1.jpg";
import { Slide } from "react-slideshow-image";

const Slider = () => {
  const images = [image1, image2, image3];

  const SlideProperties = {
    duration: 2000,
    transitionDuration: 400,
    infinite: true,
    scale: 0.7,
    arrows: false,
    slidesToShow: 1,
    canSwipe: true,
  };

  return (
    <div className="slide-container">
      <Slide {...SlideProperties}>
        {images.map((image, index) => (
          <div
            key={index}
            className=" flex items-center h-full mt-11 justify-center lg:-mt-[20px]  lg:h-[650px]"
          >
            <img className="w-full " alt="slider" src={image} />
          </div>
        ))}
      </Slide>
    </div>
  );
};

export default Slider;
